export var ModalOptions;
(function (ModalOptions) {
    ModalOptions["cancelComplete"] = "cancel-complete";
    ModalOptions["cancelConfirm"] = "cancel-confirm";
    ModalOptions["cancelError"] = "cancel-error";
    ModalOptions["cancelInitiated"] = "cancel-initiated";
    ModalOptions["default"] = "default";
})(ModalOptions || (ModalOptions = {}));
//# sourceMappingURL=modal-types.js.map